import { render, staticRenderFns } from "./DataSheetConfigContainerViewer.vue?vue&type=template&id=0c83be0e&scoped=true"
import script from "./DataSheetConfigContainerViewer.vue?vue&type=script&lang=js"
export * from "./DataSheetConfigContainerViewer.vue?vue&type=script&lang=js"
import style0 from "./DataSheetConfigContainerViewer.vue?vue&type=style&index=0&id=0c83be0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c83be0e",
  null
  
)

export default component.exports